/**
 * Static content for the Patient Consent form: the wording of each
 * authorisation and acknowledgement is printed text, not a captured answer, so
 * it lives in the frontend. Every `key` matches a column on the backend.
 */

export const PRIMARY_AUTHORIZATIONS = [
  {
    key: "consentTreatmentAdmission",
    title: "Request for Treatment and Admission",
    description:
      "I agree to the initial assessment and give the agency permission to treat me as directed by my doctor.",
  },
  {
    key: "consentDiscloseInformation",
    title: "Permission to Disclose Information",
    description:
      "Give permission for medical records to be shared with relevant healthcare providers or state or federal accrediting agencies.",
  },
  {
    key: "consentAssignmentOfBenefits",
    title: "Assignment of Benefits from Insurance",
    description:
      "Permit the agency to be paid directly. Non-covered charges are still the patient's responsibility.",
  },
];

/** Carries its own billing choice, so it renders apart from the list above. */
export const ADVANCE_BENEFICIARY_NOTICE = {
  key: "consentAdvanceBeneficiaryNotice",
  title: "CMS Advance Beneficiary Notice (ABN)",
  description:
    "Acknowledgement of financial responsibility and notification that Medicare might not cover certain procedures.",
};

export const BILLING_CONFIGURATIONS = [
  { value: "private", label: "Private" },
  { value: "medicare", label: "Medicare" },
  { value: "self_pay", label: "Self Pay" },
];

export const VISIT_FREQUENCY_ROWS = [
  { key: "freqSkilledNursing", label: "SN (Skilled Nursing)" },
  { key: "freqPhysicalTherapy", label: "PT (Physical Therapy)" },
  { key: "freqOccupationalTherapy", label: "OT (Occupational Therapy)" },
  { key: "freqSpeechTherapy", label: "ST (Speech Therapy)" },
  { key: "freqHomeHealthAide", label: "CHHA (Home Health Aide)" },
  { key: "freqMedicalSocialWorker", label: "MSW (Medical Social Worker)" },
];

export const ACKNOWLEDGEMENTS = [
  { key: "ackPatientRights", label: "Rights and Responsibilities of the Patient" },
  { key: "ackHipaaOasisPrivacy", label: "HIPAA laws and OASIS privacy rights" },
  {
    key: "ackStateHotlines",
    label: "Information about State and Joint Commission hotlines",
  },
  { key: "ackGrievanceProcess", label: "Instructed on how to lodge a grievance" },
  { key: "ackPlanOfCareReviewed", label: "I reviewed the first plan of care with" },
  {
    key: "ackSafetyEmergencyPlan",
    label: "Safety and an emergency plan for my care",
  },
  {
    key: "ackReceivedRightsCopy",
    label: "Received a copy of the Patient Rights and Responsibilities",
  },
  {
    key: "ackReceivedPrivacyNotice",
    label:
      "Acknowledge receipt of the Home Health Agency's Notice of Privacy Practices",
  },
];
